import {createContext, useContext} from "react";
import {useHeimdallUser} from "~/contexts/HeimdallUserContext";
import {useWorkspaceUsers} from "~/contexts/workspaceUsersContext";
import type {User} from "@vesta/vos-types/modules/workspaceLevel/users/domain/User";
import type {HeimdallUser} from "~/routes/_withAuthenticationStatus/-types";

type WorkspaceAuthorizationDetailsContextData = {
    heimdallUser: HeimdallUser;
    workspaceUser: User;
};

export const WorkspaceAuthorizationDetailsContext = createContext<WorkspaceAuthorizationDetailsContextData | undefined>(
    undefined,
);

export function useWorkspaceUser(): WorkspaceAuthorizationDetailsContextData {
    const workspaceAuthorizationDetails = useContext(WorkspaceAuthorizationDetailsContext);
    if (workspaceAuthorizationDetails !== undefined) {
        return workspaceAuthorizationDetails;
    }

    const heimdallUser = useHeimdallUser();
    const users = useWorkspaceUsers();
    const workspaceUser = users.find((user) => user.userId === heimdallUser.id);
    if (workspaceUser === undefined) {
        throw new Error("Workspace user not found");
    }

    return {
        heimdallUser,
        workspaceUser,
    };
}
